/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  KpiBodyDto,
  KpiResponse,
  OpportunityKpiProjection,
} from '../models/index';
import {
    KpiBodyDtoFromJSON,
    KpiBodyDtoToJSON,
    KpiResponseFromJSON,
    KpiResponseToJSON,
    OpportunityKpiProjectionFromJSON,
    OpportunityKpiProjectionToJSON,
} from '../models/index';

export interface GetCalendarEventsCampaignKpiRequest {
    kpiBodyDto: KpiBodyDto;
}

export interface GetCalendarEventsCreatedKpiRequest {
    kpiBodyDto: KpiBodyDto;
}

export interface GetCalendarEventsDoneKpiRequest {
    kpiBodyDto: KpiBodyDto;
}

export interface GetCallCreatedKpiRequest {
    kpiBodyDto: KpiBodyDto;
}

export interface GetCompanyComparisonByMetricRequest {
    metric?: GetCompanyComparisonByMetricMetricEnum;
    startDate?: string;
    endDate?: string;
}

export interface GetCompanyPerformanceComparisonRequest {
    startDate?: string;
    endDate?: string;
    metric?: GetCompanyPerformanceComparisonMetricEnum;
}

export interface GetDailyAveragesByUserRequest {
    startDate?: string;
    endDate?: string;
}

export interface GetKpiTrendsRequest {
    period?: GetKpiTrendsPeriodEnum;
    startDate?: string;
    endDate?: string;
}

export interface GetKpisBoostSalesByEmailRequest {
    email: string;
}

export interface GetKpisByCompanyRequest {
    startDate?: string;
    endDate?: string;
}

export interface GetMyKpisBoostSalesRequest {
    startDate: Date;
    endDate: Date;
}

export interface GetMyKpisOpportunitiesRequest {
    year?: number;
}

export interface GetOpportunityCreatedKpiRequest {
    kpiBodyDto: KpiBodyDto;
}

export interface GetOpportunityWinKpiRequest {
    kpiBodyDto: KpiBodyDto;
}

export interface GetSaleOrderCreateKpiRequest {
    kpiBodyDto: KpiBodyDto;
}

export interface GetSaleOrderSignedKpiRequest {
    kpiBodyDto: KpiBodyDto;
}

export interface GetTopPerformingCompaniesRequest {
    startDate?: string;
    endDate?: string;
    limit?: number;
}

export interface GetTopPerformingUsersRequest {
    limit?: number;
    startDate?: string;
    endDate?: string;
    companyId?: number;
}

export interface GetUserEfficiencyMetricsRequest {
    startDate?: string;
    endDate?: string;
    limit?: number;
}

export interface GetUserKpiSummaryRequest {
    userId: number;
    months?: number;
}

export interface GetUserPerformanceOverTimeRequest {
    userId: number;
    startDate?: string;
    endDate?: string;
    period?: GetUserPerformanceOverTimePeriodEnum;
}

export interface GetUsersMarginsRequest {
    requestBody: Array<string>;
}

/**
 * 
 */
export class KpiApi extends runtime.BaseAPI {

    /**
     * Get light version of campaign events with filters
     */
    async getCalendarEventsCampaignKpiRaw(requestParameters: GetCalendarEventsCampaignKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KpiResponse>>> {
        if (requestParameters['kpiBodyDto'] == null) {
            throw new runtime.RequiredError(
                'kpiBodyDto',
                'Required parameter "kpiBodyDto" was null or undefined when calling getCalendarEventsCampaignKpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kpi/calendar/campaign`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KpiBodyDtoToJSON(requestParameters['kpiBodyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiResponseFromJSON));
    }

    /**
     * Get light version of campaign events with filters
     */
    async getCalendarEventsCampaignKpi(requestParameters: GetCalendarEventsCampaignKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KpiResponse>> {
        const response = await this.getCalendarEventsCampaignKpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get light version of created events with filters
     */
    async getCalendarEventsCreatedKpiRaw(requestParameters: GetCalendarEventsCreatedKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KpiResponse>>> {
        if (requestParameters['kpiBodyDto'] == null) {
            throw new runtime.RequiredError(
                'kpiBodyDto',
                'Required parameter "kpiBodyDto" was null or undefined when calling getCalendarEventsCreatedKpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kpi/calendar/created`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KpiBodyDtoToJSON(requestParameters['kpiBodyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiResponseFromJSON));
    }

    /**
     * Get light version of created events with filters
     */
    async getCalendarEventsCreatedKpi(requestParameters: GetCalendarEventsCreatedKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KpiResponse>> {
        const response = await this.getCalendarEventsCreatedKpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get light version of done events with filters
     */
    async getCalendarEventsDoneKpiRaw(requestParameters: GetCalendarEventsDoneKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KpiResponse>>> {
        if (requestParameters['kpiBodyDto'] == null) {
            throw new runtime.RequiredError(
                'kpiBodyDto',
                'Required parameter "kpiBodyDto" was null or undefined when calling getCalendarEventsDoneKpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kpi/calendar/done`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KpiBodyDtoToJSON(requestParameters['kpiBodyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiResponseFromJSON));
    }

    /**
     * Get light version of done events with filters
     */
    async getCalendarEventsDoneKpi(requestParameters: GetCalendarEventsDoneKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KpiResponse>> {
        const response = await this.getCalendarEventsDoneKpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Call Created for kpi
     */
    async getCallCreatedKpiRaw(requestParameters: GetCallCreatedKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KpiResponse>>> {
        if (requestParameters['kpiBodyDto'] == null) {
            throw new runtime.RequiredError(
                'kpiBodyDto',
                'Required parameter "kpiBodyDto" was null or undefined when calling getCallCreatedKpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kpi/call/created`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KpiBodyDtoToJSON(requestParameters['kpiBodyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiResponseFromJSON));
    }

    /**
     * List Call Created for kpi
     */
    async getCallCreatedKpi(requestParameters: GetCallCreatedKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KpiResponse>> {
        const response = await this.getCallCreatedKpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get company comparison by metric
     */
    async getCompanyComparisonByMetricRaw(requestParameters: GetCompanyComparisonByMetricRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['metric'] != null) {
            queryParameters['metric'] = requestParameters['metric'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/company-metrics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get company comparison by metric
     */
    async getCompanyComparisonByMetric(requestParameters: GetCompanyComparisonByMetricRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getCompanyComparisonByMetricRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get company performance comparison
     */
    async getCompanyPerformanceComparisonRaw(requestParameters: GetCompanyPerformanceComparisonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['metric'] != null) {
            queryParameters['metric'] = requestParameters['metric'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/company-comparison`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get company performance comparison
     */
    async getCompanyPerformanceComparison(requestParameters: GetCompanyPerformanceComparisonRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getCompanyPerformanceComparisonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get daily averages by user
     */
    async getDailyAveragesByUserRaw(requestParameters: GetDailyAveragesByUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/daily-averages`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get daily averages by user
     */
    async getDailyAveragesByUser(requestParameters: GetDailyAveragesByUserRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getDailyAveragesByUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get KPI trends
     */
    async getKpiTrendsRaw(requestParameters: GetKpiTrendsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['period'] != null) {
            queryParameters['period'] = requestParameters['period'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/trends`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get KPI trends
     */
    async getKpiTrends(requestParameters: GetKpiTrendsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getKpiTrendsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Kpis Boost by email
     */
    async getKpisBoostSalesByEmailRaw(requestParameters: GetKpisBoostSalesByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['email'] == null) {
            throw new runtime.RequiredError(
                'email',
                'Required parameter "email" was null or undefined when calling getKpisBoostSalesByEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/boostsales/{email}`;
        urlPath = urlPath.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters['email'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get Kpis Boost by email
     */
    async getKpisBoostSalesByEmail(requestParameters: GetKpisBoostSalesByEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getKpisBoostSalesByEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get KPIs by company
     */
    async getKpisByCompanyRaw(requestParameters: GetKpisByCompanyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/companies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get KPIs by company
     */
    async getKpisByCompany(requestParameters: GetKpisByCompanyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getKpisByCompanyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Kpis Boost by user token
     */
    async getMyKpisBoostSalesRaw(requestParameters: GetMyKpisBoostSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling getMyKpisBoostSales().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling getMyKpisBoostSales().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = (requestParameters['endDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/boostsales/myUsers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get Kpis Boost by user token
     */
    async getMyKpisBoostSales(requestParameters: GetMyKpisBoostSalesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getMyKpisBoostSalesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Kpis Opportunities by user token
     */
    async getMyKpisOpportunitiesRaw(requestParameters: GetMyKpisOpportunitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OpportunityKpiProjection>>> {
        const queryParameters: any = {};

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/opportunities/me`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OpportunityKpiProjectionFromJSON));
    }

    /**
     * Get Kpis Opportunities by user token
     */
    async getMyKpisOpportunities(requestParameters: GetMyKpisOpportunitiesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OpportunityKpiProjection>> {
        const response = await this.getMyKpisOpportunitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Opportunity Created for kpi
     */
    async getOpportunityCreatedKpiRaw(requestParameters: GetOpportunityCreatedKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KpiResponse>>> {
        if (requestParameters['kpiBodyDto'] == null) {
            throw new runtime.RequiredError(
                'kpiBodyDto',
                'Required parameter "kpiBodyDto" was null or undefined when calling getOpportunityCreatedKpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kpi/opportunity/created`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KpiBodyDtoToJSON(requestParameters['kpiBodyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiResponseFromJSON));
    }

    /**
     * List Opportunity Created for kpi
     */
    async getOpportunityCreatedKpi(requestParameters: GetOpportunityCreatedKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KpiResponse>> {
        const response = await this.getOpportunityCreatedKpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List Opportunity Win for kpi
     */
    async getOpportunityWinKpiRaw(requestParameters: GetOpportunityWinKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KpiResponse>>> {
        if (requestParameters['kpiBodyDto'] == null) {
            throw new runtime.RequiredError(
                'kpiBodyDto',
                'Required parameter "kpiBodyDto" was null or undefined when calling getOpportunityWinKpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kpi/opportunity/win`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KpiBodyDtoToJSON(requestParameters['kpiBodyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiResponseFromJSON));
    }

    /**
     * List Opportunity Win for kpi
     */
    async getOpportunityWinKpi(requestParameters: GetOpportunityWinKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KpiResponse>> {
        const response = await this.getOpportunityWinKpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List saleOrders for kpi
     */
    async getSaleOrderCreateKpiRaw(requestParameters: GetSaleOrderCreateKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KpiResponse>>> {
        if (requestParameters['kpiBodyDto'] == null) {
            throw new runtime.RequiredError(
                'kpiBodyDto',
                'Required parameter "kpiBodyDto" was null or undefined when calling getSaleOrderCreateKpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kpi/saleOrder/create`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KpiBodyDtoToJSON(requestParameters['kpiBodyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiResponseFromJSON));
    }

    /**
     * List saleOrders for kpi
     */
    async getSaleOrderCreateKpi(requestParameters: GetSaleOrderCreateKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KpiResponse>> {
        const response = await this.getSaleOrderCreateKpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List saleOrders for kpi
     */
    async getSaleOrderSignedKpiRaw(requestParameters: GetSaleOrderSignedKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<KpiResponse>>> {
        if (requestParameters['kpiBodyDto'] == null) {
            throw new runtime.RequiredError(
                'kpiBodyDto',
                'Required parameter "kpiBodyDto" was null or undefined when calling getSaleOrderSignedKpi().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kpi/saleOrder/signed`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KpiBodyDtoToJSON(requestParameters['kpiBodyDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KpiResponseFromJSON));
    }

    /**
     * List saleOrders for kpi
     */
    async getSaleOrderSignedKpi(requestParameters: GetSaleOrderSignedKpiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<KpiResponse>> {
        const response = await this.getSaleOrderSignedKpiRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get top performing companies
     */
    async getTopPerformingCompaniesRaw(requestParameters: GetTopPerformingCompaniesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/top-companies`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get top performing companies
     */
    async getTopPerformingCompanies(requestParameters: GetTopPerformingCompaniesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getTopPerformingCompaniesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get top performing users
     */
    async getTopPerformingUsersRaw(requestParameters: GetTopPerformingUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/top-users`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get top performing users
     */
    async getTopPerformingUsers(requestParameters: GetTopPerformingUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getTopPerformingUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get total KPIs by user by month
     */
    async getTotalByUserByMonthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/users/monthly`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get total KPIs by user by month
     */
    async getTotalByUserByMonth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getTotalByUserByMonthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user efficiency metrics
     */
    async getUserEfficiencyMetricsRaw(requestParameters: GetUserEfficiencyMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/user-efficiency`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get user efficiency metrics
     */
    async getUserEfficiencyMetrics(requestParameters: GetUserEfficiencyMetricsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getUserEfficiencyMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user KPI summary
     */
    async getUserKpiSummaryRaw(requestParameters: GetUserKpiSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserKpiSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['months'] != null) {
            queryParameters['months'] = requestParameters['months'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/user/{userId}/summary`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get user KPI summary
     */
    async getUserKpiSummary(requestParameters: GetUserKpiSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getUserKpiSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get user performance over time
     */
    async getUserPerformanceOverTimeRaw(requestParameters: GetUserPerformanceOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserPerformanceOverTime().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        if (requestParameters['period'] != null) {
            queryParameters['period'] = requestParameters['period'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/kpi/user/{userId}/performance`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get user performance over time
     */
    async getUserPerformanceOverTime(requestParameters: GetUserPerformanceOverTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getUserPerformanceOverTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get margins by user
     */
    async getUsersMarginsRaw(requestParameters: GetUsersMarginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling getUsersMargins().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/kpi/margins`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get margins by user
     */
    async getUsersMargins(requestParameters: GetUsersMarginsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getUsersMarginsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetCompanyComparisonByMetricMetricEnum = {
    Total: 'total',
    OrderCount: 'orderCount',
    AveragePerUser: 'averagePerUser'
} as const;
export type GetCompanyComparisonByMetricMetricEnum = typeof GetCompanyComparisonByMetricMetricEnum[keyof typeof GetCompanyComparisonByMetricMetricEnum];
/**
 * @export
 */
export const GetCompanyPerformanceComparisonMetricEnum = {
    Total: 'total',
    OrderCount: 'orderCount',
    AveragePerUser: 'averagePerUser'
} as const;
export type GetCompanyPerformanceComparisonMetricEnum = typeof GetCompanyPerformanceComparisonMetricEnum[keyof typeof GetCompanyPerformanceComparisonMetricEnum];
/**
 * @export
 */
export const GetKpiTrendsPeriodEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;
export type GetKpiTrendsPeriodEnum = typeof GetKpiTrendsPeriodEnum[keyof typeof GetKpiTrendsPeriodEnum];
/**
 * @export
 */
export const GetUserPerformanceOverTimePeriodEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;
export type GetUserPerformanceOverTimePeriodEnum = typeof GetUserPerformanceOverTimePeriodEnum[keyof typeof GetUserPerformanceOverTimePeriodEnum];
